import axios from 'axios';

const KEY: string = "nwuziog6JX0J9M";

let api_url: string = 'https://api.cribeon.io';

// if (!!(window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('staging.') > -1)) api_url = 'https://api-staging.cribeon.io';

const instance = axios.create({
  baseURL: api_url,
  timeout: 60000,
  headers: {
    'X-KANGA-Key': KEY
  }
});

export default instance;
